<template>
  <div>
    <loading-spinner
      ref="userPanelSpinner"
      spinnerType="border"
      color="primary"
    ></loading-spinner>
    <div class="mt-2 text-secondary">
      <h4 class="display-7" v-if="false">
        <!-- <i class="fi fi-task-list mx-2"></i> -->
        <i class="fi fi-eq-vertical float-start"></i>
        <template v-if="!isMobile"> پنل کاربری </template>
      </h4>
      <hr class="hr-right" v-if="false" />

      <div class="portlet mb-2 bg-transparent">
        <div
          class="portlet-body scrollable-vertical scrollable-styled-dark pt-0"
          :style="isMobile ? '' : 'max-height: 70vh'"
        >
          <div class="row g-4">
            <div class="col-12">
              <div class="card mb-2">
                <div class="card-body">
                  <!-- <div class="mb-4" v-if="!isMobile">
                    <h2 class="h4 mb-0">دسترسی ها</h2>
                    <hr class="hr-right" />
                  </div> -->
                  <div class="row mb-1 g-2">
                    <!-- ثبت جلسه -->
                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        @click="reservingSessionButtonClick"
                        class="link-normal d-flex pointer justify-content-center align-items-center rounded text-danger animate-pulse-danger text-center"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                      >
                        <div class="">
                          <h6
                            class="mb-0 text-center"
                            :class="isMobile ? 'fs-7' : ''"
                          >
                            جلسه درمانی
                          </h6>
                        </div>
                      </a>
                    </div>
                    <!-- ثبت تست -->
                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        @click="reserveTestButtonClick"
                        class="link-normal d-flex pointer align-items-center justify-content-center rounded text-purple animate-pulse-primary"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                      >
                        <div class="">
                          <h6 class="mb-0" :class="isMobile ? 'fs-7' : ''">
                            تست و ارزیابی
                          </h6>
                        </div>
                      </a>
                    </div>

                    <!-- ثبت گروه درمانی -->
                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        @click="groupTherapyButtonClick"
                        class="link-normal pointer d-flex align-items-center rounded justify-content-center text-success animate-pulse-success"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                      >
                        <div class="">
                          <h6
                            class="mb-0 position-relative"
                            :class="isMobile ? 'fs-8' : ''"
                          >
                            گروه درمانی
                          </h6>
                        </div>
                      </a>
                    </div>

                    <!-- ثبت کارگاه آموزشی -->
                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        @click="workshopButtonClick"
                        class="link-normal pointer d-flex align-items-center justify-content-center rounded text-orange animate-pulse-warning"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                      >
                        <div class="">
                          <h6
                            class="mb-0 position-relative"
                            :class="isMobile ? 'fs-8' : ''"
                          >
                            کارگاه آموزشی
                          </h6>
                        </div>
                      </a>
                    </div>

                    <!-- پیام ها -->
                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        :href="`/panel/messagesTab/${$store.getters.userPersonID}`"
                        class="link-normal d-flex align-items-center justify-content-center rounded border border-dark border-dashed border-2"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                        v-if="false"
                      >
                        <!-- <span class="text-muted position-relative">
                          <svg
                            :width="isMobile ? '24px' : '50px'"
                            :height="isMobile ? '24px' : '50px'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-chat-dots text-gray-600 ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
                            ></path>
                            <path
                              d="m2.165 15.803.02-.004c1.83-.363 2.948-.842 3.468-1.105A9.06 9.06 0 0 0 8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6a10.437 10.437 0 0 1-.524 2.318l-.003.011a10.722 10.722 0 0 1-.244.637c-.079.186.074.394.273.362a21.673 21.673 0 0 0 .693-.125zm.8-3.108a1 1 0 0 0-.287-.801C1.618 10.83 1 9.468 1 8c0-3.192 3.004-6 7-6s7 2.808 7 6c0 3.193-3.004 6-7 6a8.06 8.06 0 0 1-2.088-.272 1 1 0 0 0-.711.074c-.387.196-1.24.57-2.634.893a10.97 10.97 0 0 0 .398-2z"
                            ></path>
                          </svg>
                          <span
                            class="position-absolute top-0 start-100 translate-middle p-1 bg-danger border border-light rounded-circle"
                            v-if="getHasUnseenMessage"
                          >
                            <span class="visually-hidden">پیام جدید</span>
                          </span>
                        </span> -->
                        <div class="">
                          <h6 class="mb-0" :class="isMobile ? 'fs-7' : ''">
                            پیام‌های دریافتی
                          </h6>
                        </div>
                      </a>
                    </div>

                    <!-- حساب کاربری -->

                    <div
                      :class="{
                        'col-md-3 col-6': checkMultipleClients(),
                        'col-md-4 col-6': !checkMultipleClients(),
                      }"
                    >
                      <a
                        :href="`/panel/userProfileTab/${$store.getters.userPersonID}`"
                        class="link-normal d-flex align-items-center justify-content-center rounded border border-dark border-dashed border-2"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                        v-if="false"
                      >
                        <span class="text-muted">
                          <!-- <svg
                            :width="isMobile ? '24px' : '50px'"
                            :height="isMobile ? '24px' : '50px'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-person-circle text-gray-600 ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0z"></path>
                            <path
                              fill-rule="evenodd"
                              d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8zm8-7a7 7 0 0 0-5.468 11.37C3.242 11.226 4.805 10 8 10s4.757 1.225 5.468 2.37A7 7 0 0 0 8 1z"
                            ></path>
                          </svg> -->
                        </span>
                        <div class="">
                          <h6 class="mb-0" :class="isMobile ? 'fs-7' : ''">
                            حساب کاربری
                          </h6>
                        </div>
                      </a>
                    </div>

                    <!-- تغییر کاربر -->

                    <div
                      class="col-md-4 col-12"
                      v-if="false && checkMultipleClients()"
                    >
                      <a
                        href="#"
                        @click="this.showClientChooseDialog()"
                        class="link-normal d-flex align-items-center rounded justify-content-center border border-dark border-dashed border-2"
                        :class="isMobile ? 'px-1 py-1' : 'px-3 py-4'"
                      >
                        <span class="text-muted">
                          <!-- <svg
                            :width="isMobile ? '24px' : '50px'"
                            :height="isMobile ? '24px' : '50px'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-person-video3 text-gray-600 ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M14 9.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-6 5.7c0 .8.8.8.8.8h6.4s.8 0 .8-.8-.8-3.2-4-3.2-4 2.4-4 3.2Z"
                            ></path>
                            <path
                              d="M2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5.243c.122-.326.295-.668.526-1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v7.81c.353.23.656.496.91.783.059-.187.09-.386.09-.593V4a2 2 0 0 0-2-2H2Z"
                            ></path>
                          </svg> -->
                        </span>
                        <div class="ps-3">
                          <h6 class="mb-0" :class="isMobile ? 'fs-7' : ''">
                            تغییر کاربر
                          </h6>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card mb-2">
                <div class="card-title">
                  <h6 class="pt-2">
                    <span class="p-2 bg-primary-soft"
                      >جلسه رواندرمانی فردی</span
                    >
                  </h6>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block"
                            >{{ getHoldedSessionCount() }} جلسه برگزار
                            شده</strong
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 my-2 border-top border-light d-lg-none">
                      <!-- mobile separator -->
                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <span class="flex-none"> </span>

                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block"
                            >{{ getWaitingToHoldCount() }} جلسه در انتظار
                            برگزاری
                          </strong>
                        </div>
                      </div>
                    </div>

                    <div class="col-12 my-2 border-top border-light d-lg-none">
                      <!-- mobile separator -->
                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <span class="flex-none">
                          <!-- <svg
                            :width="isMobile ? '24px' : '58px'"
                            :height="isMobile ? '24px' : '58px'"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            class="bi bi-calendar-date text-gray-600 ms-2"
                            viewBox="0 0 16 16"
                          >
                            <path
                              d="M6.445 11.688V6.354h-.633A12.6 12.6 0 0 0 4.5 7.16v.695c.375-.257.969-.62 1.258-.777h.012v4.61h.675zm1.188-1.305c.047.64.594 1.406 1.703 1.406 1.258 0 2-1.066 2-2.871 0-1.934-.781-2.668-1.953-2.668-.926 0-1.797.672-1.797 1.809 0 1.16.824 1.77 1.676 1.77.746 0 1.23-.376 1.383-.79h.027c-.004 1.316-.461 2.164-1.305 2.164-.664 0-1.008-.45-1.05-.82h-.684zm2.953-2.317c0 .696-.559 1.18-1.184 1.18-.601 0-1.144-.383-1.144-1.2 0-.823.582-1.21 1.168-1.21.633 0 1.16.398 1.16 1.23z"
                            ></path>
                            <path
                              d="M3.5 0a.5.5 0 0 1 .5.5V1h8V.5a.5.5 0 0 1 1 0V1h1a2 2 0 0 1 2 2v11a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1V.5a.5.5 0 0 1 .5-.5zM1 4v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4H1z"
                            ></path>
                          </svg> -->
                        </span>

                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block">تاریخ جلسه بعدی</strong>
                          <span class="text-decoration-none small" dir="ltr">{{
                            getNextSessionDateTime()
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="card mb-2">
                <div class="card-title">
                  <h6 class="pt-2">
                    <span class="p-2 bg-primary-soft">جلسه درمانی گروهی</span>
                  </h6>
                </div>
                <div class="card-body p-4">
                  <div class="row">
                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <span class="flex-none"> </span>

                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block"
                            >{{ getWorkshopHoldedSessionCount() }} جلسه برگزار
                            شده</strong
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 my-2 border-top border-light d-lg-none">
                      <!-- mobile separator -->
                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <span class="flex-none"> </span>

                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block"
                            >{{ getWorkshopWaitingToHoldCount() }} جلسه در
                            انتظار برگزاری</strong
                          >
                        </div>
                      </div>
                    </div>

                    <div class="col-12 my-2 border-top border-light d-lg-none">
                      <!-- mobile separator -->
                    </div>

                    <div class="col-lg-4">
                      <div class="d-flex align-items-center">
                        <span class="flex-none"> </span>

                        <div class="w-100 ps-3" :class="isMobile ? 'fs-8' : ''">
                          <strong class="d-block">تاریخ جلسه بعدی</strong>
                          <span class="text-decoration-none small" dir="ltr">{{
                            getWorkshopNextSessionDateTime()
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="card mb-2">
                <div class="card-body">
                  <div class="row g-1 align-items-center">
                    <div
                      class="card shadow mb-3 border-3 border-top-0 border-bottom-0 border-start-0 border-secondary border-end"
                      v-if="discountCodeData.length == 0"
                    >
                      <div class="card-body d-flex justify-content-between">
                        <div class="w-100 pt-1 text-center">
                          <strong class="d-block fs-6 fw-medium">
                            کد تخفیفی وجود ندارد</strong
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-md-4"
                      v-for="item in discountCodeData"
                      :key="item.id"
                    >
                      <div
                        class="card border-0 shadow transition-hover-top transition-all-ease-500 rounded-xl"
                        :class="isMobile ? 'my-1' : 'my-4'"
                      >
                        <div
                          class="rounded-xl rounded-bottom-0 py-1"
                          :class="{
                            'bg-light': item.isValid,
                            'bg-danger': !item.isValid,
                          }"
                        >
                          <h3 class="text-center mb-0">
                            <span
                              class="smaller badge bg-secondary-soft rounded-pill p-2"
                            >
                              <span
                                :class="{ 'text-success': item.isValid }"
                                class="mb-0 mt-3 display-7"
                                >%</span
                              >
                              <span
                                :class="{ 'text-success': item.isValid }"
                                class="pricetable-count mb-0 display-7"
                                >{{ item.discountPercent }}</span
                              >
                            </span>
                          </h3>

                          <p
                            class="text-center fw-light"
                            :class="{
                              'text-muted': item.isValid,
                              'text-white': !item.isValid,
                            }"
                          >
                            {{ item.isValid ? item.remainSessionCount : 0 }}
                            جلسه باقی مانده
                          </p>
                        </div>

                        <div class="w-100" style="height: 10px">
                          <svg
                            style="margin-top: -60px"
                            width="100%"
                            height="50"
                            fill="#ffffff"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 1000 300"
                            preserveAspectRatio="none"
                          >
                            <path
                              style="opacity: 0.15"
                              d="M 1000 299 l 2 -279 c -155 -36 -310 135 -415 164 c -102.64 28.35 -149 -32 -232 -31 c -80 1 -142 53 -229 80 c -65.54 20.34 -101 15 -126 11.61 v 54.39 z"
                            ></path>
                            <path
                              style="opacity: 0.3"
                              d="M 1000 286 l 2 -252 c -157 -43 -302 144 -405 178 c -101.11 33.38 -159 -47 -242 -46 c -80 1 -145.09 54.07 -229 87 c -65.21 25.59 -104.07 16.72 -126 10.61 v 22.39 z"
                            ></path>
                            <path
                              style="opacity: 1"
                              d="M 1000 300 l 1 -230.29 c -217 -12.71 -300.47 129.15 -404 156.29 c -103 27 -174 -30 -257 -29 c -80 1 -130.09 37.07 -214 70 c -61.23 24 -108 15.61 -126 10.61 v 22.39 z"
                            ></path>
                          </svg>
                        </div>

                        <div class="p-2 p-lg-2">
                          <div class="d-flex mb-2">
                            <div
                              class="badge badge-ico-sm rounded-circle float-start"
                              :class="{
                                'bg-success-soft': item.isValid,
                                'bg-danger-soft': !item.isValid,
                              }"
                            >
                              <i class="fi fi-check"></i>
                            </div>

                            <p class="text-dark fw-light mb-0 px-1 small">
                              معتبر تا {{ getPersianDate(item.finishDate) }} |
                              <small
                                class="gregorianDateClass"
                                dir="ltr"
                                v-if="isOverseas()"
                                >{{ getGregorianDate(item.finishDate) }}
                              </small>
                            </p>
                          </div>
                          <div class="d-flex mb-2">
                            <div
                              class="badge badge-ico-sm rounded-circle float-start"
                              :class="{
                                'bg-success-soft': item.isValid,
                                'bg-danger-soft': !item.isValid,
                              }"
                            >
                              <i class="fi fi-check"></i>
                            </div>

                            <p
                              class="text-dark fw-light mb-0 px-1 small"
                              v-if="
                                item.therapyTypeTitle || item.sessionTypeTitle
                              "
                            >
                              جلسات: {{ item.therapyTypeTitle }} -
                              {{ item.sessionTypeTitle }}
                            </p>
                            <p
                              class="text-dark fw-light mb-0 px-1 small"
                              v-if="
                                !item.therapyTypeTitle && !item.sessionTypeTitle
                              "
                            >
                              قابل استفاده در تمامی جلسات
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LoadingSpinner from '../../../../components/utility/loadingSpinner/LoadingSpinner.vue';
import axios from 'axios';
import { isMobile } from 'mobile-device-detect';
export default {
  components: {
    LoadingSpinner,
  },
  watch: {
    async $route(to, from) {
      if (to.fullPath != from.fullPath) {
        let that = this;
        await that.getClientPanelData();
        //await that.getDiscountCodeData();
        await that.RefreshWalletList();
        await that.GetProfilePicture();
      }
    },
  },
  data() {
    return {
      isMobile: isMobile,
      clientPanelData: [],
      discountCodeData: [],
    };
  },
  computed: {
    getHasUnseenMessage() {
      return (this.$store.getters.userHasUnseenMessage ?? 'false') === 'true';
    },
  },
  inject: ['showClientChooseDialog', 'GetProfilePicture', 'RefreshWalletList'],
  methods: {
    async getClientPanelData() {
      let that = this;
      this.$refs.userPanelSpinner.show();
      await axios
        .get(
          `/Basic/Client/GetClientPanelData?id=${that.$store.getters.userPersonID}`
        )
        .then((response) => {
          that.clientPanelData = response.data;
        })
        .catch((error) => {
          if (!error.response.data.success) {
            let errorMessages = error.response.data.errors.map(
              (i) => i.errorMessage
            );
            errorMessages.forEach((item) => {
              that.$refs.notification.show({
                type: 'error',
                title: item,
              });
            });
          }
        })
        .finally(() => {
          this.$refs.userPanelSpinner?.hide();
        });
    },
    getHoldedSessionCount() {
      let data = this.clientPanelData.filter((f) => f.key == 'HoldedSessions');
      if (data && data.length > 0) {
        return data[0].value;
      }
      return 0;
    },
    getWorkshopHoldedSessionCount() {
      let data = this.clientPanelData.filter(
        (f) => f.key == 'WorkshopHoldedSessions'
      );
      if (data && data.length > 0) {
        return data[0].value;
      }
      return 0;
    },
    checkMultipleClients() {
      let clientList = this.$store.getters.clientList;
      return clientList && clientList.length > 0;
    },
    getWaitingToHoldCount() {
      let data = this.clientPanelData.filter((f) => f.key == 'WaitingToHold');
      if (data && data.length > 0) {
        return data[0].value;
      }
      return 0;
    },
    getWorkshopWaitingToHoldCount() {
      let data = this.clientPanelData.filter(
        (f) => f.key == 'WorkshopWaitingToHold'
      );
      if (data && data.length > 0) {
        return data[0].value;
      }
      return 0;
    },

    getNextSessionDateTime() {
      let data = this.clientPanelData.filter(
        (f) => f.key == 'NextSessionDateTime'
      );
      if (data && data.length > 0) {
        return data[0].value ?? '---';
      }
      return '---';
    },
    getWorkshopNextSessionDateTime() {
      let data = this.clientPanelData.filter(
        (f) => f.key == 'WorkshopNextSessionDateTime'
      );
      if (data && data.length > 0) {
        return data[0].value ?? '---';
      }
      return '---';
    },

    // async getDiscountCodeData() {
    //   let that = this;
    //   this.$refs.userPanelSpinner.show();
    //   await axios
    //     .get(
    //       `/FN/DiscountCode/GetPersonDiscountCode/${that.$store.getters.userPersonID}`
    //     )
    //     .then((response) => {
    //       that.discountCodeData = response.data;
    //     })
    //     .catch(() => {
    //       this.$refs.notification.show({
    //         type: 'error',
    //         title: `عملیات دریافت کد های تخفیف با مشکل مواجه شد`,
    //       });
    //     })
    //     .finally(() => {
    //       this.$refs.userPanelSpinner?.hide();
    //     });
    // },
    getPersianDate(date) {
      if (!date) {
        return '';
      }
      /* eslint-disable */
      return new persianDate(new Date(date)).format('L');
    },
    getGregorianDate(date) {
      // eslint-disable-next-line
      return getGregorianDate(date);
    },
    isOverseas() {
      return this.$store.getters.isOverseas == true;
    },
    reservingSessionButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'therapySession');
      this.$router.push({
        name: 'selectTherapist',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    reserveTestButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'testSession');
      this.$router.push({
        name: 'selectTestSession',
        params: { id: this.$store.getters.userPersonID },
      });
    },
    workshopButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'workshopList');
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 2 },
      });
    },
    groupTherapyButtonClick() {
      this.$store.dispatch('setClientCurrentPanel', 'groupTherapyList');
      this.$router.push({
        name: 'workshopTab',
        params: { id: this.$store.getters.userPersonID, type: 1 },
      });
    },
  },
  async mounted() {
    let that = this;
    await that.getClientPanelData();
    //await that.getDiscountCodeData();
  },
};
</script>
